import { gql } from '@apollo/client'

export const GET_NOTIFICATIONS_BY_ID = gql`
  query getNotificationsById($needsClientNameArgs: NeedsClientNameArgs!) {
    getNotificationsById(needsClientNameArgs: $needsClientNameArgs) {
      title
      message
      read
      url
      createdAt
      variant
    }
  }
`

export const ADD_NOTIFICATION = gql`
  mutation addNotification($notificationPayloadArgs: NotificationPayloadArgs!) {
    addNotification(notificationPayloadArgs: $notificationPayloadArgs)
  }
`

export const MARK_AS_READ_NOTIFICATION = gql`
  mutation markAsReadNotification(
    $markAsReadNotificationArgs: MarkAsReadNotificationArgs!
  ) {
    markAsReadNotification(
      markAsReadNotificationArgs: $markAsReadNotificationArgs
    )
  }
`
